module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-modern_v2-aefe42c92fe60e5ec58282c9798a700e.pdf";